module.exports = __WEBPACK_EXTERNAL_MODULE_182__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/core-client/js/core-client/i18n/Formatter"
// module id = 182
// module chunks = 0